import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { nanoid } from 'nanoid'
import { Css3Icon, DockerIcon, FigmaIcon, FirebaseIcon, FlutterIcon, JavascriptIcon, MongoDBIcon, NestIcon, NextJsIcon, NginxIcon, NodeJsIcon, PythonIcon, ReactIcon } from '../../components/icons';
import SkillBar from '../../components/skills/skillBar';
import SkillBarProps from '../../model/skill-bar-props';
import SkillsProps from '../../model/skills-props';

const max = 116;

const skillsList = [
    {
        key:nanoid(),
        icon: <FlutterIcon
                viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
            />,
        title:'Flutter',
        progress: max  * 0.7,
        color: '#41D0FD'
    },
    {
        key: nanoid(),
        icon: <JavascriptIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Javascript',
        progress: max * 0.8,
        color: '#F5DE19'
    },
    {
        key: nanoid(),
        icon: <FigmaIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Figma',
        progress: max * 0.65,
        color: '#F24E1E'
    },
    {
        key: nanoid(),
        icon: <Css3Icon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'CSS3',
        progress: max * 0.9,
        color: '#1572B6'
    },
    {
        key: nanoid(),
        icon: <NextJsIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Next Js',
        progress: max * 0.6,
        color: '#F8F8F8'
    },
    {
        key: nanoid(),
        icon: <FirebaseIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Firebase',
        progress: max * 0.6,
        color: '#F6820C'
    },
    {
        key: nanoid(),
        icon: <NginxIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'NGINX',
        progress: max * 0.79,
        color: '#009639'
    },
    {
        key: nanoid(),
        icon: <NodeJsIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Node Js',
        progress: max * 0.8,
        color: '#0FA958'
    },
    {
        key: nanoid(),
        icon: <PythonIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Python',
        progress: max * 0.6,
        color: '#366C99'
    },
    {
        key: nanoid(),
        icon: <MongoDBIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Mongo DB',
        progress: max * 0.75,
        color: '#499D4A'
    },
    {
        key: nanoid(),
        icon: <NestIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'NEST',
        progress: max * 0.60,
        color: '#E0234E'
    },
    {
        key: nanoid(),
        icon: <DockerIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'Docker',
        progress: max * 0.50,
        color: '#2396ED'
    },
    {
        key: nanoid(),
        icon: <ReactIcon
            viewBox="0 0 112 112"
            sx={{ fontSize: '120px', paddingTop: 2, paddingBottom: 2 }}
        />,
        title: 'React',
        progress: max * 0.75,
        color: '#00D8FF'
    },
];

export default function Skills(props: SkillsProps){
    return (
        <Container sx={{ marginTop: !props.isMobile ? '8em' : '0' , paddingTop: !props.isMobile ? 0 : '4em'}}>
            <Typography component='h2' variant='h6' color='#fff' fontWeight='medium' >
                My Skills
            </Typography>

            <Grid 
                container
                justifyContent={!props.isMobile ? 'start' : 'center'}
                alignItems={"center"}
                sx={{ marginTop: '4em',marginBottom: '4em' }}
            >
                    {
                        skillsList.map((skill)=>{
                            return (
                                <SkillBar {...skill}/>
                            )
                        })
                    }
            </Grid>
        </Container>
    );
}